import { IconProps } from "./_types";

const Recording = ({ size = 21, color = "#FFB1AF", squareColor = "#FF5D58", ...other }: IconProps & { squareColor?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M10.5 1.75C8.17936 1.75 5.95376 2.67187 4.31282 4.31282C2.67187 5.95376 1.75 8.17936 1.75 10.5C1.75 12.8206 2.67187 15.0462 4.31282 16.6872C5.95376 18.3281 8.17936 19.25 10.5 19.25C12.8206 19.25 15.0462 18.3281 16.6872 16.6872C18.3281 15.0462 19.25 12.8206 19.25 10.5C19.25 8.17936 18.3281 5.95376 16.6872 4.31282C15.0462 2.67187 12.8206 1.75 10.5 1.75ZM10.5 18C6.365 18 3 14.635 3 10.5C3 6.365 6.365 3 10.5 3C14.635 3 18 6.365 18 10.5C18 14.635 14.635 18 10.5 18Z"
        fill={color}
      />
      <rect x="6.3335" y="6.33337" width="8.33333" height="8.33333" rx="2" fill={squareColor} />
    </svg>
  );
};

export default Recording;
